import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslation from './locales/en/translation.json';
import heTranslation from './locales/he/translation.json';

// Initialize i18next
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslation,
            },
            he: {
                translation: heTranslation,
            },
        },
        lng: 'en', // default language
        fallbackLng: 'he', // fallback language if the current language doesn't have a translation
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    });

export default i18n;
